import React from 'react';
import { Avatar as MuiBaseAvatar, AvatarProps, styled } from '@mui/material';
import { MaterialSymbol } from "react-material-symbols";

interface CustomAvatarProps extends AvatarProps {
  children?: React.ReactNode,
  defaultIcon?: "retailer" | "manufacturer",
  outlined?: boolean,
  shape?: 'circle' | 'square',
  size?: number,
}

const StyledAvatar = styled(MuiBaseAvatar)<CustomAvatarProps>((
  { outlined, theme, shape, size },
) => {
  return ({
    padding: shape === 'square' ? '2.5px' : '8px',
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: theme.palette.background.default,
    border: outlined ? '1px solid #E0E0E0' : 'none',
    borderRadius: shape === 'square' ? '4px' : '50%',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  });
});

export const Avatar = ({
  children,
  defaultIcon,
  outlined = true,
  src,
  shape = 'square',
  size = 56, 
  ...rest
}: CustomAvatarProps) => {
  return <StyledAvatar outlined={outlined} shape={shape} size={size} src={src} {...rest}>
    {!src && children}
    {!src && !children && defaultIcon && (
      <MaterialSymbol
        color='#525252'
        fill
        icon={defaultIcon === 'retailer' ? 'store' : 'manufacturing'}
        size={size * .75}
      />
    )}
  </StyledAvatar>;
};